export default __webpack_public_path__ + "static/media/fast-server.4b34d9be.svg";